const STATUS_MAP = {
  open: "Open",
  rejected: "Rejected",
  cancelled: "Cancelled",
  closed: "Closed",
  sent_to_gp: "Sent to GP"
};

export const getFormattedStatus = ({ status }) => STATUS_MAP[status] || status;
